export default __webpack_public_path__ + "static/alawwal_desktop-3def24cd2ea98c5e02d3df9a05c02db9.mp4";